export default {
    colors: {
        primary: '#FE4040',
        secondary: '#FE4040'
    },
    overrideFunction: ({ colors }) => ({
        h1BorderColor: colors.primary,
        h2BorderColor: colors.primary,
        colorLink: colors.primary,
        navItemTransform: 'uppercase',
        subNavBg: colors.secondary,
        subNavMobileBackgroundColor: colors.secondary,
        partnerOfferMain: colors.primary,
        partnerCardMainDiscountColor: colors.primary,
        howItWorkBlockBoldColor: colors.primary,
        faqLinkTextColor: colors.black
    })
};



// WEBPACK FOOTER //
// ./src/style/applicationSpecific/bfmTheme.js